export default __webpack_public_path__ + "static/media/HF.1526bba0.svg";